<template>
    <div>
        <studies></studies>
    </div>
</template>

<script>
import studies from '@/components/studies'
export default {
    components:{
        studies
    },
    data(){
        return{

        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/studies/studies.vue